var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"p2p"},[_c('div',{staticClass:"shop"},[_c('Shop',{key:_vm.$route.params + ''})],1),_c('div',{staticClass:"main"},[_c('Maintrade')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }